export var ProgressSize;
(function (ProgressSize) {
    ProgressSize["control"] = "control";
    ProgressSize["container"] = "container";
    ProgressSize["page"] = "page";
})(ProgressSize || (ProgressSize = {}));
